//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactView from "./view.vue";

export default {
  name: "contact",
  components: { ContactView },
  mounted() {
    window.scrollTo(0, 0);
  },
};
